import styled from "@emotion/styled";

const StyledBannerAlert = styled.div({
  position: "fixed",
  textAlign: "center",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 85,
  margin: 0,
});

const StyledParagraph = styled.p({
  margin: "0 0 24px",
  textAlign: "left",
});

export { StyledBannerAlert, StyledParagraph };
